<template>
    <split-pane  :min-percent='10' :default-percent='14' split="vertical" style="background:white; height:100%">
        <template slot="paneL"  >
            <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium"  ></el-input> 
            <el-tree :data="treeData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        node-key="id"    
                      
                        :default-expanded-keys="expkeys"   
                        :style="{background:'#fFF',overflow:'auto',height: tabHeight}"
                        highlight-current
                        :filter-node-method="filterNode"
                        ref="eltree"
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.parentid =='#' "  >
                        <span  style=" font-size:14px;color:#389;font-size:14px;font-weight:600"><i class="iconfont icon-fenlei" style="color:#389;font-size:18px;font-weight:700"></i> {{ node.label}} </span>
                    </span>                  
                    <span v-else  > 
                        <span v-if="data.icon=='DOC'" style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-wenjian" style="margin-right:5px;color:#389"></i>{{ node.label}} </span>
                        <span v-else style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-wenjianmulu" style="margin-right:5px;"></i>{{ node.label}} </span>
                    </span>
                </template>
            </el-tree>
        </template>
        <template slot="paneR"> 
            <div style="background:#fff;height:91vh;overflow-y:auto; ">
                <div style="background:#fff;font-size:20px;font-weight:700;color:#409d8f;line-height:40px;text-align:center;width:100%">
                    {{docObj['FILETYNM']}}<span v-if="docObj['FILETYNM']">：</span>{{docObj['TITLE']}}
                </div>
                <div class="one-toolbar">
                    <span class="spanRow">文档描述</span> 
                </div>
                <div v-html="v_html" style="margin-top:4px;line-height:25px;font-size:12px;padding-left:5px;background:#fff;min-height:100px"></div>
                <div class="one-toolbar">
                    <span class="spanRow">文档附件</span> 
                </div>
                <div style="display:flex;margin-left:10px;flex-wrap:wrap;margin-top:8px;margin-bottom:10px"  >
                    <div v-if="FILEPATH" style="border:1px solid #ccc;height:350px ;width:350px;margin-right:30px;">  
                        <div v-if="FILEPATH &&FILEPATH.indexOf('.pdf')>-1" style="width:350px;height:325px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image :preview-src-list="[FILEPATH]" v-else fit="fill"  style="width:350px;height:323px;" :src="FILEPATH"> </el-image>
                        <div style="line-height:25px;height:25px;background:#e8eaec;width:350px; display:flex;justify-content:space-between">
                            <div class="menuitem">{{NAME1}}</div>
                            <div style="float:right;width:50px">
                                <el-link :underline="false" @click="imgPreview( FILEPATH)"><Icon type="ios-search" /> 预览</el-link>
                            </div>
                        </div>
                    </div>
                    <div v-if="FILEPATH2" style="border:1px solid #ccc;height:350px ;width:350px;margin-right:30px;"> 
                        <div v-if="FILEPATH2 &&FILEPATH2.indexOf('.pdf')>-1" style="width:350px;height:325px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH2" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image :preview-src-list="[FILEPATH2]" v-else fit="fill"  style="width:350px;height:323px;" :src="FILEPATH2"> </el-image>
                        <div style="line-height:25px;height:25px;background:#e8eaec;width:350px; display:flex;justify-content:space-between">
                            <div class="menuitem">{{NAME2}}</div>
                            <div style="float:right;width:50px">
                                <el-link :underline="false" @click="imgPreview( FILEPATH2)"><Icon type="ios-search" /> 预览</el-link>
                            </div>
                        </div>
                    </div>

                    <div v-if="FILEPATH3" style="border:1px solid #ccc;height:350px ;width:350px;margin-right:10px;">  
                        <div v-if="FILEPATH3 &&FILEPATH3.indexOf('.pdf')>-1" style="width:350px;height:325px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH3" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image :preview-src-list="[FILEPATH3]" v-else fit="fill"  style="width:350px;height:323px;" :src="FILEPATH3"></el-image>
                        <div style="line-height:25px;height:25px;background:#e8eaec;width:350px; display:flex;justify-content:space-between">
                            <div class="menuitem">{{NAME3}}</div>
                            <div style="float:right;width:50px">
                                <el-link :underline="false"  @click="imgPreview( FILEPATH3)"><Icon type="ios-search" /> 预览</el-link>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
            <!-- 预览图片 -->
            <el-dialog v-dialogDrag :visible.sync="showViewer" :width="tabWidth" append-to-body top="3vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预览</span>
                </div>
                <el-image fit="scale-down"  :style="{'margin':'5px auto',height:imgHeight, 'width':'100% '}" :src="listurl"></el-image>
            </el-dialog>
        </template>
        
    </split-pane>
</template>

<script>
    import { getTabColOrData,getBaseData } from '../../api/user';
 
    export default {
        name: "infor_detail",
        data(){
            return {
                expkeys:['0'],
                v_html:'',
                v_idseq:'',
                v_lstseq:'',
                v_username:this.$cookies.get('v_telno'), //api 请求用户
                
                v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
                v_url:'xuper_auth/getTableRecMany', //动态请求url接口
                docObj:{},
                FILEPATH:'',
                FILEPATH2:'',
                FILEPATH3:'',
                showViewer:false,
                listurl:'',
                NAME1:'',
                NAME2:'',
                NAME3:'',
                defaultProps: {  //el-tree 默认字段属性
                    children: 'children',
                    id:'id',
                    icon:'icon',
                    label: 'label'
                },
                treeData:[],
                filterText: '',
            }
        },
        created(){
            if (this.v_username){ 
                this.v_idseq=this.$route.query.p_idseq 
                this.v_lstseq=this.$route.query.p_lstseq 
                //初始化
                this.getData(); //树形数据
 
            }else{
                let routeUrl = this.$router.resolve({
                    path: '/login',
                    query: {},
                });
                window.open(routeUrl.href, '_self');
            }
        },
        mounted(){
            this.getNoteList('0','0')
            this.initKeys()
        },
        computed:{
            tabWidth(){
                return (window.innerWidth-160) + 'px'
            } ,
            imgHeight: function() {
                return (window.innerHeight - 140) + 'px';
            },
            tabHeight: function() {
                return (window.innerHeight - 115) + 'px';
            },
        },
        watch:{
            filterText(val) {
                this.$refs.eltree.filter(val)
            }
        },
                                     
        methods:{
            initKeys(){       
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'corpid', p_value:this.v_corpid,p_key2:'parentno',p_value2:'0',p_table:'V_INFO_TREEDOC'},
                }).then(res=>{ 
                    if (res.code=='200') {
                        res.result.forEach(item =>{
                            this.expkeys.push(item['CODE'])
                        }) 
                    }
                })
            },
            // 获取 树形控件数据
            getData() {  
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getElTreeData' ,
                    data: {p_table:'V_INFO_TREEDOC',p_cond:' AND corpid in (\'0\',\''+this.v_corpid+'\')'}
                }).then(function(res){                  
                    vm.treeData =res.result   
                    if(res.result.length > 0 ){
                        //'nextTick()' 下次dom更新时触发回调函数
                        vm.$nextTick().then(() =>{
                            //使用setCurrentKey方法的时候必须将其放在nextTick中,要等数据更新渲染完再调用,否则找不到对应元素
                            vm.$refs.eltree.setCurrentKey(vm.treeid)
                            //vm.expkeys.push(vm.treeid)
                        })
                    }               
                })                              
            },
            //节点过滤
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            //节点点击
            handleNodeClick(data ){
                this.nodeLabel=data.label;            
                this.treeid =data.id
                if (this.treeid.indexOf('-')>-1){
                    let v_idseq =this.treeid.substring(0,this.treeid.indexOf('-') )
                    let v_lstseq=this.treeid.substring( this.treeid.indexOf('-')+1)
                    console.log(v_idseq,v_lstseq)
                    this.getNoteList(v_idseq,v_lstseq)
                }else{
                    this.getNoteList('0','0')
                }
            },
            getNoteList(idseq,lstseq){
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getClobData',
                    data: {p_key:'idseq',p_value: idseq,p_key2:'lstseq',p_value2: lstseq, p_table:'V_HR_DOCLOB' },
                }).then(res=>{ 
                    if (res.result.length>0){
                        this.v_html =res.result[0].note  
                        this.FILEPATH =res.result[0].path1    
                        this.FILEPATH2 =res.result[0].path2
                        this.FILEPATH3 =res.result[0].path3     
                        this.NAME1 =res.result[0].name1
                        this.NAME2 =res.result[0].name2
                        this.NAME3 =res.result[0].name3
                    }else{
                        this.v_html =''  
                        this.FILEPATH =''    
                        this.FILEPATH2 =''
                        this.FILEPATH3 =''     
                        this.NAME1 =''
                        this.NAME2 =''
                        this.NAME3 =''
                    }
                })
                getTabColOrData(this.v_url,'V_hr_docitm','idseq', idseq,'lstseq', lstseq,'','','').then((res) => {
                    if (res.result.length>0 ){
                        this.docObj =res.result[0]
                    }else{
                        this.docObj ={}
                    }
                })
            },
            //图片预览
            imgPreview(path){
                if (path &&path.indexOf('.pdf')>-1){
                    let routeUrl = this.$router.resolve({
                        path: '/fullPreview',
                        query: {fileUrl: path},
                    });
                    window.open(routeUrl.href, '_blank');
                }else{
                    this.showViewer=true
                    this.listurl=path
                }
            },
        }
    }
</script>
<style lang="less" scoped>
   .menuitem {
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    padding-left:2px;
    width:290px;
  }
</style>
<style lang="less">
 
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>

